import ODEImg4 from '../../Images/ODEImg4.PNG'
import ODEImg5 from '../../Images/ODEImg5.PNG'
import ODEImg6 from '../../Images/ODEImg6.PNG'
import ODEImg7 from '../../Images/ODEImg7.PNG'
import ODEImg8 from '../../Images/ODEImg8.PNG'


const S = {
  wrapper: { marginTop:'10px', padding:'40px', border:'3px solid grey', fontFamily:"'Georgia', serif", color:'#1a1a2e', lineHeight:'1.7' },
  h1: { fontSize:'2rem', fontWeight:'700', borderBottom:'3px solid #2E75B6', paddingBottom:'8px', marginBottom:'24px', color:'#1F3864' },
  h2: { fontSize:'1.3rem', fontWeight:'700', color:'#2E75B6', marginTop:'36px', marginBottom:'12px', borderLeft:'4px solid #2E75B6', paddingLeft:'10px' },
  p: { marginBottom:'12px', fontSize:'0.97rem' },
  infoBox: { background:'#EBF3FB', border:'2px solid #2E75B6', borderRadius:'6px', padding:'16px 20px', margin:'16px 0' },
  infoBoxTitle: { fontWeight:'700', fontFamily:"'Courier New', monospace", fontSize:'0.88rem', color:'#1F3864', marginBottom:'8px' },
  infoBoxItem: { fontSize:'0.9rem', margin:'4px 0', paddingLeft:'12px', borderLeft:'2px solid #2E75B6' },
  table: { width:'100%', borderCollapse:'collapse', marginBottom:'20px', fontSize:'0.92rem' },
  th: { background:'#2E75B6', color:'#fff', padding:'10px 14px', textAlign:'left', fontWeight:'700', fontSize:'0.9rem' },
  tdE: { padding:'10px 14px', borderBottom:'1px solid #ccd9ea', verticalAlign:'top', background:'#f5f9ff' },
  tdO: { padding:'10px 14px', borderBottom:'1px solid #ccd9ea', verticalAlign:'top', background:'#fff' },
  tdL: { fontWeight:'600', color:'#1F3864', whiteSpace:'nowrap', width:'220px' },
  code: { fontFamily:"'Courier New', monospace", fontSize:'0.88rem', whiteSpace:'pre-wrap' },
  dWrap: { margin:'24px 0', background:'#f8fbff', border:'1px solid #ccd9ea', borderRadius:'8px', padding:'20px' },
  dTitle: { fontWeight:'700', fontSize:'0.95rem', color:'#1F3864', marginBottom:'12px', textAlign:'center', letterSpacing:'0.02em' },
  dCaption: { fontSize:'0.84rem', color:'#555', textAlign:'center', marginTop:'10px', fontStyle:'italic' },
};

function InfoBox({ title, items }) {
  return (
    <div style={S.infoBox}>
      <div style={S.infoBoxTitle}>{title}</div>
      {items.map((item, i) => <div key={i} style={S.infoBoxItem}>{item}</div>)}
    </div>
  );
}

function Table2({ rows }) {
  return (
    <table style={S.table}>
      <thead><tr>
        <th style={{ ...S.th, width:'220px' }}>Concept</th>
        <th style={S.th}>Formula / Notes</th>
      </tr></thead>
      <tbody>
        {rows.map(([label, content], i) => (
          <tr key={i}>
            <td style={{ ...(i%2===0?S.tdE:S.tdO), ...S.tdL }}>{label}</td>
            <td style={{ ...(i%2===0?S.tdE:S.tdO), ...S.code }}>{content}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

// ── Shared arrow marker ──────────────────────────────────────────
function Defs() {
  return (
    <defs>
      <marker id="arrowB" markerWidth="8" markerHeight="6" refX="8" refY="3" orient="auto">
        <polygon points="0 0,8 3,0 6" fill="#1F3864"/>
      </marker>
      <marker id="arrowP" markerWidth="8" markerHeight="6" refX="8" refY="3" orient="auto">
        <polygon points="0 0,8 3,0 6" fill="#9b59b6"/>
      </marker>
      <marker id="arrowG" markerWidth="8" markerHeight="6" refX="8" refY="3" orient="auto">
        <polygon points="0 0,8 3,0 6" fill="#27ae60"/>
      </marker>
    </defs>
  );
}

// ── Diagram 1: The Big Picture — s-plane and the idea ────────────
function DiagramBigPicture() {
  const W = 900, H = 360;

  // Left: a causal time-domain signal decaying sine
  // f(t) = e^{-t} sin(2t) u(t)
  const lX = 10, lW = 340, lH = 260, lY = 50;
  const ox = lX + 50, oy = lY + lH * 0.55;
  const scx = (lW - 60) / 6.5, scy = 75;
  const tx = t => ox + t * scx;
  const ty = y => oy - y * scy;
  const fpts = [];
  for (let t = 0; t <= 6.5; t += 0.04)
    fpts.push([t, t >= 0 ? Math.exp(-t) * Math.sin(2 * t) : 0]);

  function pathD(pts, txf, tyf, ymin, ymax) {
    let d = ''; let pen = false;
    for (const [t, y] of pts) {
      const px = txf(t), py = tyf(y);
      if (py < ymin || py > ymax) { pen = false; continue; }
      d += (pen ? 'L' : 'M') + px.toFixed(1) + ' ' + py.toFixed(1) + ' ';
      pen = true;
    }
    return d;
  }

  // Right: s-plane with pole markers for F(s)=2/((s+1)^2+4)
  // poles at s = -1 ± 2j
  const rX = 530, rW = 360, rH = 280, rY = 40;
  const sox = rX + rW / 2 - 30, soy = rY + rH / 2;
  const sscx = 48, sscy = 48;
  const stx = sig => sox + sig * sscx;
  const sty = om  => soy - om * sscy;

  // ROC shading: Re(s) > -1
  const rocX = stx(-1);

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>From Time Domain to the s-Plane — The Laplace Transform at a Glance</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{ width:'100%', display:'block' }}>
        <Defs/>

        {/* ── Left panel: time domain ── */}
        <rect x={lX} y={lY - 22} width={lW} height={lH + 22} rx={5} fill="#fff" stroke="#ccd9ea"/>
        <text x={lX + lW/2} y={lY - 30} textAnchor="middle" fontSize="13" fill="#1F3864" fontWeight="700">Time Domain  f(t) = e^(−t)sin(2t)·u(t)</text>

        {/* axes */}
        <line x1={tx(0)} y1={ty(-1.3)} x2={tx(0)} y2={ty(1.3)} stroke="#1F3864" strokeWidth="1.4" markerEnd="url(#arrowB)"/>
        <line x1={tx(-0.2)} y1={oy} x2={tx(6.5)} y2={oy} stroke="#1F3864" strokeWidth="1.4" markerEnd="url(#arrowB)"/>
        <text x={tx(6.5)+5} y={oy+5} fontSize="13" fill="#1F3864" fontWeight="700">t</text>
        <text x={tx(0)+4} y={ty(1.3)-4} fontSize="13" fill="#1F3864" fontWeight="700">f(t)</text>
        {[1,2,3,4,5,6].map(v => (
          <g key={v}>
            <line x1={tx(v)} y1={oy-3} x2={tx(v)} y2={oy+3} stroke="#bbb" strokeWidth="1"/>
            <text x={tx(v)} y={oy+15} textAnchor="middle" fontSize="10" fill="#bbb">{v}</text>
          </g>
        ))}
        {[-1,1].map(v => (
          <text key={v} x={tx(0)-6} y={ty(v)+4} textAnchor="end" fontSize="10" fill="#bbb">{v}</text>
        ))}

        {/* shaded area under curve */}
        <path
          d={pathD(fpts, tx, ty, ty(1.3), oy) + `L${tx(6.5)},${oy} L${tx(0)},${oy} Z`}
          fill="#2E75B6" fillOpacity="0.08"/>
        <path d={pathD(fpts, tx, ty, ty(1.3), oy)} fill="none" stroke="#2E75B6" strokeWidth="2.4"/>

        {/* u(t) label */}
        <text x={tx(0.15)} y={ty(0.9)} fontSize="11" fill="#2E75B6" fontStyle="italic">causal: 0 for t&lt;0</text>

        {/* exponential envelope */}
        {(() => {
          let d = ''; let pen = false;
          for (let t = 0; t <= 5; t += 0.05) {
            const px = tx(t), py = ty(Math.exp(-t));
            if (py < lY) { pen=false; continue; }
            d += (pen?'L':'M')+px.toFixed(1)+' '+py.toFixed(1)+' '; pen=true;
          }
          return <path d={d} fill="none" stroke="#c0392b" strokeWidth="1.3" strokeDasharray="5,3"/>;
        })()}
        <text x={tx(1.6)} y={ty(0.25)} fontSize="10" fill="#c0392b" fontStyle="italic">e^(−t) envelope</text>

        {/* Arrow between panels */}
        <line x1={lX+lW+10} y1={lY+lH/2} x2={rX-10} y2={rY+rH/2}
          stroke="#9b59b6" strokeWidth="2.5" markerEnd="url(#arrowP)"/>
        <text x={(lX+lW+rX)/2} y={lY+lH/2-14} textAnchor="middle" fontSize="12" fill="#9b59b6" fontWeight="700">Laplace</text>
        <text x={(lX+lW+rX)/2} y={lY+lH/2+2} textAnchor="middle" fontSize="12" fill="#9b59b6" fontWeight="700">Transform</text>
        <text x={(lX+lW+rX)/2} y={lY+lH/2+16} textAnchor="middle" fontSize="10" fill="#9b59b6">∫₀^∞ f(t)e^(−st)dt</text>

        {/* ── Right panel: s-plane ── */}
        <rect x={rX} y={rY} width={rW} height={rH} rx={5} fill="#fff" stroke="#ccd9ea"/>
        <text x={rX+rW/2} y={rY-8} textAnchor="middle" fontSize="13" fill="#1F3864" fontWeight="700">s-Plane (s = σ + jω)</text>

        {/* ROC shading */}
        <rect x={rocX} y={rY+2} width={rX+rW-rocX-4} height={rH-4} rx={3} fill="#27ae60" fillOpacity="0.10"/>
        <text x={rocX+30} y={rY+22} fontSize="11" fill="#27ae60" fontWeight="700">ROC</text>
        <text x={rocX+20} y={rY+38} fontSize="10" fill="#27ae60">Re(s) &gt; −1</text>

        {/* ROC boundary */}
        <line x1={rocX} y1={rY+2} x2={rocX} y2={rY+rH-2} stroke="#27ae60" strokeWidth="1.8" strokeDasharray="6,3"/>

        {/* Axes */}
        <line x1={rX+8} y1={soy} x2={rX+rW-8} y2={soy} stroke="#1F3864" strokeWidth="1.3" markerEnd="url(#arrowB)"/>
        <line x1={sox} y1={rY+rH-8} x2={sox} y2={rY+8} stroke="#1F3864" strokeWidth="1.3" markerEnd="url(#arrowB)"/>
        <text x={rX+rW-6} y={soy+14} fontSize="12" fill="#1F3864" fontWeight="700">σ</text>
        <text x={sox+6} y={rY+12} fontSize="12" fill="#1F3864" fontWeight="700">jω</text>

        {/* Grid ticks */}
        {[-3,-2,-1,0,1,2].map(v => (
          <g key={v}>
            <line x1={stx(v)} y1={soy-3} x2={stx(v)} y2={soy+3} stroke="#bbb" strokeWidth="1"/>
            <text x={stx(v)} y={soy+14} textAnchor="middle" fontSize="10" fill="#bbb">{v}</text>
          </g>
        ))}
        {[-2,-1,1,2].map(v => (
          <g key={v}>
            <line x1={sox-3} y1={sty(v)} x2={sox+3} y2={sty(v)} stroke="#bbb" strokeWidth="1"/>
            <text x={sox-6} y={sty(v)+4} textAnchor="end" fontSize="10" fill="#bbb">{v}j</text>
          </g>
        ))}

        {/* Poles at -1 ± 2j */}
        {[2,-2].map(im => (
          <g key={im}>
            <text x={stx(-1)} y={sty(im)+5} textAnchor="middle" fontSize="18" fill="#c0392b" fontWeight="700">×</text>
            <text x={stx(-1)+14} y={sty(im)+(im>0?-8:16)} fontSize="11" fill="#c0392b" fontWeight="700">
              pole: −1{im>0?'+':''}{im}j
            </text>
          </g>
        ))}

        {/* Dashed lines from poles to axes */}
        <line x1={stx(-1)} y1={sty(2)-8} x2={stx(-1)} y2={soy} stroke="#c0392b" strokeWidth="1" strokeDasharray="4,3" strokeOpacity="0.5"/>
        <line x1={stx(-1)} y1={sty(-2)+8} x2={stx(-1)} y2={soy} stroke="#c0392b" strokeWidth="1" strokeDasharray="4,3" strokeOpacity="0.5"/>
        <line x1={rX+8} y1={sty(2)} x2={stx(-1)-4} y2={sty(2)} stroke="#c0392b" strokeWidth="1" strokeDasharray="4,3" strokeOpacity="0.5"/>
        <line x1={rX+8} y1={sty(-2)} x2={stx(-1)-4} y2={sty(-2)} stroke="#c0392b" strokeWidth="1" strokeDasharray="0,0" strokeOpacity="0"/>

        {/* F(s) formula */}
        <rect x={rX+8} y={rY+rH-62} width={rW-16} height={56} rx={4} fill="#EBF3FB" stroke="#2E75B6" strokeWidth="1.2"/>
        <text x={rX+rW/2} y={rY+rH-44} textAnchor="middle" fontSize="12" fill="#1F3864" fontWeight="700">F(s) = 2 / [(s+1)² + 4]</text>
        <text x={rX+rW/2} y={rY+rH-26} textAnchor="middle" fontSize="10.5" fill="#555">Poles where denominator = 0: s = −1 ± 2j</text>
        <text x={rX+rW/2} y={rY+rH-10} textAnchor="middle" fontSize="10.5" fill="#555">Pole real part (−1) sets decay rate of f(t)</text>

        {/* Bottom formula bar */}
        <rect x={lX} y={lY+lH+8} width={W-20} height={38} rx={4} fill="#EBF3FB" stroke="#2E75B6" strokeWidth="1.2"/>
        <text x={W/2} y={lY+lH+22} textAnchor="middle" fontSize="12" fill="#1F3864" fontWeight="700">Laplace Transform: </text>
        <text x={W/2+110} y={lY+lH+22} textAnchor="middle" fontSize="12" fill="#2E75B6" fontFamily="'Courier New',monospace" fontWeight="700">F(s) = L{"{f(t)}"} = ∫₀^∞ f(t)·e^(−st) dt,  s = σ + jω ∈ ℂ</text>
        <text x={W/2} y={lY+lH+38} textAnchor="middle" fontSize="11" fill="#555">The variable s is complex. Setting s=jω recovers the Fourier Transform (when the ROC includes the imaginary axis).</text>
      </svg>
      <div style={S.dCaption}>The Laplace Transform maps a causal time-domain signal f(t) to a function F(s) of the complex variable s=σ+jω. The poles of F(s) in the s-plane encode the natural frequencies and decay rates of the signal — poles to the left of the imaginary axis correspond to decaying modes, poles on it to sustained oscillations, and poles to the right to growing (unstable) modes. The shaded Region of Convergence (ROC) is where the integral converges.</div>
    </div>
  );
}

// ── Diagram 2: Transform Pairs Table (visual) ────────────────────
function DiagramPairs() {
  const W = 900, H = 360;

  // 5 classic pairs, each with a mini time-domain sketch
  const pairs = [
    {
      name: 'Unit Step',
      ft: 'u(t)',
      Fs: '1/s',
      color: '#2E75B6', bg: '#EBF3FB',
      draw: (ox,oy,sw,sh) => <>
        <line x1={ox-sw*0.3} y1={oy} x2={ox} y2={oy} stroke="#2E75B6" strokeWidth="2"/>
        <line x1={ox} y1={oy} x2={ox} y2={oy-sh*0.7} stroke="#2E75B6" strokeWidth="2"/>
        <line x1={ox} y1={oy-sh*0.7} x2={ox+sw*0.9} y2={oy-sh*0.7} stroke="#2E75B6" strokeWidth="2"/>
        <text x={ox-sw*0.15} y={oy-sh*0.35} fontSize="9" fill="#2E75B6">1</text>
      </>,
    },
    {
      name: 'Exponential',
      ft: 'e^(−at)u(t)',
      Fs: '1/(s+a)',
      color: '#27ae60', bg: '#f0fff4',
      draw: (ox,oy,sw,sh) => {
        let d='M'; const pts=[];
        for(let t=0;t<=sw*0.9;t+=1){const y=Math.exp(-2.5*t/sw)*sh*0.75; pts.push(`${ox+t},${oy-y}`);}
        return <path d={'M'+pts.join('L')} fill="none" stroke="#27ae60" strokeWidth="2"/>;
      },
    },
    {
      name: 'Ramp',
      ft: 't·u(t)',
      Fs: '1/s²',
      color: '#e07b00', bg: '#fff7ee',
      draw: (ox,oy,sw,sh) => <>
        <line x1={ox-sw*0.3} y1={oy} x2={ox} y2={oy} stroke="#e07b00" strokeWidth="2"/>
        <line x1={ox} y1={oy} x2={ox+sw*0.9} y2={oy-sh*0.8} stroke="#e07b00" strokeWidth="2"/>
      </>,
    },
    {
      name: 'Sine',
      ft: 'sin(ωt)·u(t)',
      Fs: 'ω/(s²+ω²)',
      color: '#c0392b', bg: '#fff0f0',
      draw: (ox,oy,sw,sh) => {
        const pts=[];
        for(let t=0;t<=sw*0.9;t+=1){const y=Math.sin(6*t/sw)*sh*0.65; pts.push(`${ox+t},${oy-y}`);}
        return <><path d={'M'+pts.join('L')} fill="none" stroke="#c0392b" strokeWidth="2"/>
          <line x1={ox-sw*0.3} y1={oy} x2={ox} y2={oy} stroke="#c0392b" strokeWidth="2"/></>;
      },
    },
    {
      name: 'Dirac Delta',
      ft: 'δ(t)',
      Fs: '1',
      color: '#9b59b6', bg: '#f5d0ff',
      draw: (ox,oy,sw,sh) => <>
        <line x1={ox} y1={oy} x2={ox} y2={oy-sh*0.85} stroke="#9b59b6" strokeWidth="3" markerEnd="url(#arrowP)"/>
        <line x1={ox-sw*0.3} y1={oy} x2={ox-0.5} y2={oy} stroke="#9b59b6" strokeWidth="2"/>
        <line x1={ox+0.5} y1={oy} x2={ox+sw*0.9} y2={oy} stroke="#9b59b6" strokeWidth="2"/>
      </>,
    },
  ];

  // s-plane pole positions for each pair
  const polePlots = [
    { poles:[{re:0,im:0,type:'p'}], zeros:[], desc:'Pole at origin\n(marginally stable)' },
    { poles:[{re:-2,im:0,type:'p'}], zeros:[], desc:'Pole at s=−a\n(stable for a>0)' },
    { poles:[{re:0,im:0,type:'p'},{re:0,im:0.3,type:'p2'}], zeros:[], desc:'Double pole\nat origin' },
    { poles:[{re:0,im:2,type:'p'},{re:0,im:-2,type:'p'}], zeros:[], desc:'Conjugate poles\non jω axis' },
    { poles:[], zeros:[], desc:'No poles:\nflat spectrum' },
  ];

  const cW = 168, cH = 310, gap = 7;

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Classic Laplace Transform Pairs — f(t) on the left, F(s) and pole locations on the right</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{ width:'100%', display:'block' }}>
        <Defs/>
        {pairs.map(({ name, ft, Fs, color, bg, draw }, i) => {
          const x = i*(cW+gap) + 4;
          const y = 12;
          const gY = y+84, gH = 75, gW = cW-16;
          const ox2 = x+8, oy2 = gY+gH*0.6;

          // s-plane mini box
          const spY = gY+gH+12, spH=72, spW=cW-16;
          const spox = x+8+spW/2, spoy=spY+spH/2;
          const spsc = spW/7;
          const { poles, desc } = polePlots[i];

          return (
            <g key={name}>
              <rect x={x} y={y} width={cW} height={cH} rx={6} fill={bg} stroke={color} strokeWidth="2"/>
              <rect x={x} y={y} width={cW} height={38} rx={6} fill={color}/>
              <rect x={x} y={y+26} width={cW} height={12} fill={color}/>
              <text x={x+cW/2} y={y+22} textAnchor="middle" fontSize="12" fill="#fff" fontWeight="700">{name}</text>

              {/* f(t) label */}
              <text x={x+cW/2} y={y+52} textAnchor="middle" fontSize="11" fill={color} fontFamily="'Courier New',monospace" fontWeight="700">{ft}</text>
              <text x={x+cW/2} y={y+68} textAnchor="middle" fontSize="11" fill="#555">↓  L{'{·}'}</text>

              {/* F(s) label */}
              <rect x={x+8} y={y+74} width={cW-16} height={24} rx={3} fill="#fff" fillOpacity="0.8"/>
              <text x={x+cW/2} y={y+91} textAnchor="middle" fontSize="13" fill={color} fontFamily="'Courier New',monospace" fontWeight="700">{Fs}</text>

              {/* Time domain sketch */}
              <rect x={x+6} y={gY} width={gW} height={gH} rx={3} fill="#fff" stroke="#ddd"/>
              <line x1={ox2} y1={gY} x2={ox2} y2={gY+gH} stroke="#eee" strokeWidth="1"/>
              <line x1={x+6} y1={oy2} x2={x+6+gW} y2={oy2} stroke="#bbb" strokeWidth="1"/>
              <text x={x+6+gW/2} y={gY-4} textAnchor="middle" fontSize="9" fill="#888">f(t)</text>
              {draw(ox2, oy2, gW-2, gH)}

              {/* s-plane mini */}
              <rect x={x+8} y={spY} width={spW} height={spH} rx={3} fill="#fff" stroke="#ddd"/>
              <line x1={x+8} y1={spoy} x2={x+8+spW} y2={spoy} stroke="#bbb" strokeWidth="1"/>
              <line x1={spox} y1={spY} x2={spox} y2={spY+spH} stroke="#bbb" strokeWidth="1"/>
              <text x={x+8+spW/2} y={spY-4} textAnchor="middle" fontSize="9" fill="#888">s-plane</text>
              {poles.map(({re,im,type},pi)=>(
                <text key={pi} x={spox+re*spsc} y={spoy-im*spsc+6}
                  textAnchor="middle" fontSize="15" fill={color} fontWeight="700">×</text>
              ))}

              {/* Desc */}
              <text x={x+cW/2} y={spY+spH+18} textAnchor="middle" fontSize="9.5" fill="#555">{desc.split('\n')[0]}</text>
              <text x={x+cW/2} y={spY+spH+31} textAnchor="middle" fontSize="9.5" fill="#555">{desc.split('\n')[1]}</text>
            </g>
          );
        })}
      </svg>
      <div style={S.dCaption}>Each panel shows the time-domain waveform (middle), the s-domain formula (top), and the location of poles in the s-plane (bottom). The step has a pole at the origin (constant level); the decaying exponential has a pole on the negative real axis (distance from origin = decay rate); the sine has conjugate poles on the imaginary axis (oscillation frequency = imaginary part). Poles in the left half-plane signal stable, decaying behaviour.</div>
    </div>
  );
}

// ── Diagram 3: Solving an ODE with Laplace ──────────────────────
function DiagramODESolve() {
  const W = 900, H = 340;

  // Solve y'' + 3y' + 2y = u(t), y(0)=0, y'(0)=0
  // Y(s) = 1/(s(s+1)(s+2))
  // Partial fractions: 1/2·1/s - 1/(s+1) + 1/2·1/(s+2)
  // y(t) = (1/2 - e^{-t} + 1/2·e^{-2t}) u(t)
  const yt = t => t>=0 ? 0.5 - Math.exp(-t) + 0.5*Math.exp(-2*t) : 0;

  const steps = [
    {
      step:'1', title:'Original ODE', color:'#2E75B6', bg:'#EBF3FB',
      lines:["y″ + 3y′ + 2y = u(t)", "y(0)=0,  y′(0)=0", "(2nd order, ICs included)"],
    },
    {
      step:'2', title:'Apply L{·}', color:'#27ae60', bg:'#f0fff4',
      lines:["s²Y − sy(0) − y′(0)", "+ 3(sY − y(0)) + 2Y", "= 1/s"],
    },
    {
      step:'3', title:'Use ICs, solve for Y(s)', color:'#e07b00', bg:'#fff7ee',
      lines:["(s²+3s+2)Y(s) = 1/s", "Y(s) = 1/[s(s+1)(s+2)]", "(Algebraic — easy!)"],
    },
    {
      step:'4', title:'Partial Fractions', color:'#c0392b', bg:'#fff0f0',
      lines:["Y(s) = A/s + B/(s+1)", "        + C/(s+2)", "A=½, B=−1, C=½"],
    },
    {
      step:'5', title:'Inverse Laplace', color:'#9b59b6', bg:'#f5d0ff',
      lines:["y(t) = ½u(t) − e^(−t)", "       + ½e^(−2t)", "for t ≥ 0"],
    },
  ];

  const stepW = 152, stepH = 135, stepY = 16, gapS = 10;

  // Solution plot
  const gX = 20, gY = 172, gW = 860, gH = 140;
  const ox = gX+50, oy = gY+gH-18, scx=(gW-60)/7, scy=100;
  const tx = t=>ox+t*scx, ty=y=>oy-y*scy;

  // component curves
  const comps = [
    { fn: t=>0.5, color:'#2E75B6', label:'½ (step)' },
    { fn: t=>-Math.exp(-t), color:'#c0392b', label:'−e^(−t)' },
    { fn: t=>0.5*Math.exp(-2*t), color:'#27ae60', label:'½e^(−2t)' },
  ];

  function curvePath(fn, tmax) {
    let d=''; let pen=false;
    for(let t=0;t<=tmax;t+=0.06){
      const py=ty(fn(t));
      if(py<gY||py>gY+gH){pen=false;continue;}
      d+=(pen?'L':'M')+tx(t).toFixed(1)+' '+py.toFixed(1)+' '; pen=true;
    }
    return d;
  }

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Solving y″ + 3y′ + 2y = u(t) with Zero Initial Conditions via Laplace Transform</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{ width:'100%', display:'block' }}>
        <Defs/>

        {/* Step boxes */}
        {steps.map(({ step, title, color, bg, lines }, i) => {
          const x = i*(stepW+gapS) + 14;
          return (
            <g key={step}>
              <rect x={x} y={stepY} width={stepW} height={stepH} rx={6} fill={bg} stroke={color} strokeWidth="2"/>
              <rect x={x} y={stepY} width={stepW} height={34} rx={6} fill={color}/>
              <rect x={x} y={stepY+22} width={stepW} height={12} fill={color}/>
              <text x={x+stepW/2} y={stepY+16} textAnchor="middle" fontSize="10.5" fill="#fff" fontWeight="700">STEP {step}: {title}</text>
              {lines.map((l,li)=>(
                <text key={li} x={x+stepW/2} y={stepY+52+li*22}
                  textAnchor="middle" fontSize="10.5" fill={li===0?color:'#444'}
                  fontFamily="'Courier New',monospace" fontWeight={li===0?"700":"400"}>{l}</text>
              ))}
              {i<steps.length-1 && (
                <polygon points={`${x+stepW+4},${stepY+stepH/2-4} ${x+stepW+4+10},${stepY+stepH/2} ${x+stepW+4},${stepY+stepH/2+4}`} fill={color}/>
              )}
            </g>
          );
        })}

        {/* Solution graph */}
        <rect x={gX} y={gY} width={gW} height={gH} rx={5} fill="#fff" stroke="#ccd9ea"/>
        <text x={gX+gW/2} y={gY-6} textAnchor="middle" fontSize="12" fill="#1F3864" fontWeight="700">
          Solution y(t) = ½ − e^(−t) + ½e^(−2t)  and its three components
        </text>

        {/* Grid */}
        {[0,1,2,3,4,5,6,7].map(v=>(
          <g key={v}>
            <line x1={tx(v)} y1={gY} x2={tx(v)} y2={gY+gH} stroke="#f0f0f0" strokeWidth="1"/>
            <text x={tx(v)} y={gY+gH+13} textAnchor="middle" fontSize="10" fill="#bbb">{v}</text>
          </g>
        ))}
        <line x1={tx(0)} y1={oy} x2={tx(7)} y2={oy} stroke="#1F3864" strokeWidth="1.3"/>
        <line x1={ox} y1={gY+4} x2={ox} y2={gY+gH} stroke="#1F3864" strokeWidth="1.3"/>
        <text x={tx(7)+8} y={oy+4} fontSize="12" fill="#1F3864" fontWeight="700">t</text>
        {[0.5].map(v=>(
          <g key={v}>
            <text x={ox-6} y={ty(v)+4} textAnchor="end" fontSize="10" fill="#bbb">{v}</text>
            <line x1={tx(0)} y1={ty(v)} x2={tx(7)} y2={ty(v)} stroke="#f5f5f5" strokeWidth="1"/>
          </g>
        ))}

        {/* Steady-state line */}
        <line x1={tx(0)} y1={ty(0.5)} x2={tx(7)} y2={ty(0.5)} stroke="#2E75B6" strokeWidth="1.2" strokeDasharray="6,4" strokeOpacity="0.5"/>
        <text x={tx(6.2)} y={ty(0.5)-6} fontSize="10" fill="#2E75B6">steady state = 0.5</text>

        {/* Component curves faint */}
        {comps.map(({fn,color,label},i)=>(
          <g key={i}>
            <path d={curvePath(fn,7)} fill="none" stroke={color} strokeWidth="1.5" strokeDasharray="5,3" strokeOpacity="0.55"/>
            <text x={tx(0.25+i*1.5)} y={ty(fn(0.25+i*1.5))-9} fontSize="10" fill={color} fontStyle="italic">{label}</text>
          </g>
        ))}

        {/* Total solution bold */}
        <path d={curvePath(yt,7)} fill="none" stroke="#1F3864" strokeWidth="2.6"/>
        <text x={tx(1.2)} y={ty(yt(1.2))+16} fontSize="11" fill="#1F3864" fontWeight="700">y(t) total</text>
      </svg>
      <div style={S.dCaption}>The Laplace method converts a differential equation with initial conditions into an algebraic equation in Y(s) — no guessing of solution form needed. The three steps are: (1) transform, using the differentiation rule to absorb initial conditions; (2) solve algebraically for Y(s); (3) invert via partial fractions and a table. The solution graph shows the three components (dashed) summing to the total response (black), which rises from zero and settles at the steady-state value of 0.5.</div>
    </div>
  );
}

// ── Diagram 4: Partial Fractions — the inversion engine ─────────
function DiagramPartialFractions() {
  const W = 900, H = 305;

  const cases = [
    {
      title:'Distinct Real Poles', color:'#2E75B6', bg:'#EBF3FB',
      form:'F(s) = N(s)/[(s+a)(s+b)]',
      pf:  'A/(s+a) + B/(s+b)',
      coverup:'A = F(s)·(s+a)|_{s=−a}',
      inv: 'Ae^(−at) + Be^(−bt)',
      note:'One term per pole\nCover-up rule for numerator',
    },
    {
      title:'Repeated Real Poles', color:'#27ae60', bg:'#f0fff4',
      form:'F(s) = N(s)/(s+a)²',
      pf:  'A/(s+a) + B/(s+a)²',
      coverup:'B = F(s)·(s+a)²|_{s=−a}',
      inv: '(At + B)e^(−at)  ·  te^(−at) rule',
      note:'Extra term per repeated root\nte^(−at) appears in inverse',
    },
    {
      title:'Complex Conjugate Poles', color:'#c0392b', bg:'#fff0f0',
      form:'F(s) = N(s)/[(s+a)²+b²]',
      pf:  '(As+B)/[(s+a)²+b²]',
      coverup:'Complete the square\nthen match sin/cos form',
      inv: 'e^(−at)[C₁cos(bt)+C₂sin(bt)]',
      note:'Keep conjugate pair together\nGives damped oscillation',
    },
    {
      title:'Improper Fraction', color:'#9b59b6', bg:'#f5d0ff',
      form:'deg(N) ≥ deg(D)',
      pf:  'Polynomial + proper fraction',
      coverup:'Long-divide first\nthen partial-fraction remainder',
      inv: 'Polynomial → derivatives of δ(t)\n+ standard terms',
      note:'Always check degrees first!\nArise in derivative-heavy systems',
    },
  ];

  const cW = 214, cH = 268, gap = 7;

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Partial Fraction Decomposition — The Engine of the Inverse Laplace Transform</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{ width:'100%', display:'block' }}>
        <Defs/>
        {cases.map(({ title, color, bg, form, pf, coverup, inv, note }, i) => {
          const x = i*(cW+gap)+5, y=10;
          const rows=[
            {label:'Form', val:form},
            {label:'Decompose', val:pf},
            {label:'Find coeffs', val:coverup},
            {label:'Inverse L', val:inv},
          ];
          return (
            <g key={title}>
              <rect x={x} y={y} width={cW} height={cH} rx={6} fill={bg} stroke={color} strokeWidth="2"/>
              <rect x={x} y={y} width={cW} height={36} rx={6} fill={color}/>
              <rect x={x} y={y+24} width={cW} height={12} fill={color}/>
              <text x={x+cW/2} y={y+22} textAnchor="middle" fontSize="11.5" fill="#fff" fontWeight="700">{title}</text>
              {rows.map(({label,val},ri)=>(
                <g key={ri}>
                  <rect x={x+6} y={y+44+ri*50} width={cW-12} height={44} rx={3}
                    fill={ri%2===0?'#fff':'rgba(255,255,255,0.5)'} stroke={color} strokeWidth="0.8"/>
                  <text x={x+14} y={y+58+ri*50} fontSize="9.5" fill={color} fontWeight="700">{label}:</text>
                  <text x={x+14} y={y+72+ri*50} fontSize="10" fill="#333" fontFamily="'Courier New',monospace">{val}</text>
                </g>
              ))}
              <text x={x+cW/2} y={y+cH-18} textAnchor="middle" fontSize="9.5" fill="#666" fontStyle="italic">{note.split('\n')[0]}</text>
              <text x={x+cW/2} y={y+cH-6} textAnchor="middle" fontSize="9.5" fill="#666" fontStyle="italic">{note.split('\n')[1]}</text>
            </g>
          );
        })}
      </svg>
      <div style={S.dCaption}>Partial fractions decompose a rational F(s) into a sum of simple terms, each matching a standard Laplace pair. The cover-up rule (multiply both sides by the pole factor, then substitute the pole value) gives the coefficient for each distinct real pole instantly. Repeated poles require one extra term per repetition; complex conjugate poles are handled as a single quadratic block matching the damped-sine form.</div>
    </div>
  );
}

// ── Diagram 5: Properties ────────────────────────────────────────
function DiagramProperties() {
  const W = 900, H = 300;

  const props = [
    {
      title:'Linearity', color:'#2E75B6', bg:'#EBF3FB',
      formula:'L{af+bg} = aF+bG',
      desc:'Superposition holds. Transform term by term — the most-used property.',
      icon:(x,y)=><>
        <text x={x+75} y={y+46} textAnchor="middle" fontSize="12" fill="#2E75B6" fontFamily="'Courier New',monospace">a·F(s)</text>
        <text x={x+75} y={y+62} textAnchor="middle" fontSize="12" fill="#27ae60" fontFamily="'Courier New',monospace">+ b·G(s)</text>
      </>,
    },
    {
      title:'Differentiation', color:'#27ae60', bg:'#f0fff4',
      formula:"L{f'} = sF(s)−f(0)",
      desc:"Each derivative multiplies by s and subtracts an initial condition — converts ODEs to algebra.",
      icon:(x,y)=><>
        <text x={x+75} y={y+46} textAnchor="middle" fontSize="11" fill="#27ae60" fontFamily="'Courier New',monospace">f′ → sF−f(0)</text>
        <text x={x+75} y={y+62} textAnchor="middle" fontSize="11" fill="#27ae60" fontFamily="'Courier New',monospace">f″ → s²F−sf(0)−f′(0)</text>
      </>,
    },
    {
      title:'Integration', color:'#e07b00', bg:'#fff7ee',
      formula:'L{∫₀ᵗf dτ} = F(s)/s',
      desc:'Integration in time divides by s. Dual of differentiation — adds a pole at the origin.',
      icon:(x,y)=><>
        <text x={x+75} y={y+52} textAnchor="middle" fontSize="14" fill="#e07b00" fontFamily="'Courier New',monospace">F(s) / s</text>
      </>,
    },
    {
      title:'Time Shifting', color:'#c0392b', bg:'#fff0f0',
      formula:'L{f(t−a)u(t−a)} = e^(−as)F(s)',
      desc:'Delay by a seconds → multiply by e^(−as). Used for piecewise/switched inputs.',
      icon:(x,y)=><>
        <path d={`M${x+20},${y+62} Q${x+50},${y+28} ${x+80},${y+62}`} fill="none" stroke="#ccd9ea" strokeWidth="1.5" strokeDasharray="3,2"/>
        <path d={`M${x+40},${y+62} Q${x+70},${y+28} ${x+100},${y+62}`} fill="none" stroke="#c0392b" strokeWidth="2"/>
        <text x={x+75} y={y+76} textAnchor="middle" fontSize="9" fill="#c0392b">← delay a →</text>
      </>,
    },
    {
      title:'s-Domain Shift', color:'#9b59b6', bg:'#f5d0ff',
      formula:'L{e^(at)f(t)} = F(s−a)',
      desc:'Multiply by exponential in time → shift poles left/right in s-plane. Key for damped responses.',
      icon:(x,y)=><>
        <text x={x+75} y={y+42} textAnchor="middle" fontSize="11" fill="#9b59b6" fontFamily="'Courier New',monospace">F(s) → F(s−a)</text>
        <text x={x+75} y={y+58} textAnchor="middle" fontSize="20" fill="#9b59b6">←</text>
        <text x={x+75} y={y+76} textAnchor="middle" fontSize="9" fill="#9b59b6">poles shift by +a</text>
      </>,
    },
    {
      title:'Initial & Final Value', color:'#1F3864', bg:'#e8ecf4',
      formula:'f(0⁺)=lim s→∞ sF(s)\nf(∞) =lim s→0  sF(s)',
      desc:'Read initial and final values directly from F(s) without inverting — great for quick checks.',
      icon:(x,y)=><>
        <text x={x+75} y={y+44} textAnchor="middle" fontSize="10.5" fill="#1F3864" fontFamily="'Courier New',monospace">s→∞: initial</text>
        <text x={x+75} y={y+60} textAnchor="middle" fontSize="10.5" fill="#1F3864" fontFamily="'Courier New',monospace">s→0:  final</text>
      </>,
    },
  ];

  const cW = 142, cH = 280, gap = 8;

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Key Properties of the Laplace Transform</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{ width:'100%', display:'block' }}>
        <Defs/>
        {props.map(({ title, color, bg, formula, desc, icon }, i) => {
          const x = i*(cW+gap)+5, y=10;
          return (
            <g key={title}>
              <rect x={x} y={y} width={cW} height={cH} rx={6} fill={bg} stroke={color} strokeWidth="2"/>
              <rect x={x} y={y} width={cW} height={36} rx={6} fill={color}/>
              <rect x={x} y={y+24} width={cW} height={12} fill={color}/>
              <text x={x+cW/2} y={y+22} textAnchor="middle" fontSize="11" fill="#fff" fontWeight="700">{title}</text>

              {/* formula box */}
              <rect x={x+6} y={y+44} width={cW-12} height={formula.includes('\n')?36:24} rx={3} fill="#fff" fillOpacity="0.8"/>
              {formula.split('\n').map((line,li)=>(
                <text key={li} x={x+cW/2} y={y+58+li*16} textAnchor="middle"
                  fontSize="9.5" fill={color} fontFamily="'Courier New',monospace" fontWeight="700">{line}</text>
              ))}

              {/* icon area */}
              {icon(x, y + (formula.includes('\n')?82:70))}

              {/* desc */}
              <foreignObject x={x+6} y={y+160} width={cW-12} height={112}>
                <div xmlns="http://www.w3.org/1999/xhtml"
                  style={{fontSize:'9.5px', color:'#444', lineHeight:'1.5'}}>{desc}</div>
              </foreignObject>
            </g>
          );
        })}
      </svg>
      <div style={S.dCaption}>These six properties let you manipulate Laplace Transforms without re-computing the integral. The differentiation rule is the key workhorse: it absorbs initial conditions and converts every derivative into multiplication by s, reducing ODEs to algebraic equations. The initial/final value theorems let you read off f(0⁺) and f(∞) directly from F(s) — useful for sanity-checking solutions before fully inverting.</div>
    </div>
  );
}

// ── Diagram 6: Transfer Functions and Control ────────────────────
function DiagramTransferFunctions() {
  const W = 900, H = 340;

  // Block diagram of a feedback control system
  // R(s) → [summing junction] → [C(s) controller] → [P(s) plant] → Y(s)
  //                 ↑                                        |
  //                 └──────────── [H(s) sensor] ←───────────┘

  // Step response of second-order system: H(s)=ωn²/(s²+2ζωns+ωn²)
  // ζ=0.3, ωn=2
  const zetas=[0.1,0.3,0.7,1.2];
  const colors=['#c0392b','#e07b00','#27ae60','#2E75B6'];
  const wn=2;

  function stepResp(zeta, t) {
    if(t<=0) return 0;
    const wn2=wn*wn, wd=wn*Math.sqrt(Math.abs(1-zeta*zeta));
    if(zeta<1) {
      const phi=Math.acos(zeta);
      return 1 - Math.exp(-zeta*wn*t)/Math.sqrt(1-zeta*zeta)*Math.sin(wd*t+phi);
    } else if(zeta===1) {
      return 1-(1+wn*t)*Math.exp(-wn*t);
    } else {
      const s1=-wn*(zeta-Math.sqrt(zeta*zeta-1)), s2=-wn*(zeta+Math.sqrt(zeta*zeta-1));
      return 1 + s2/(s1-s2)*Math.exp(s1*t) - s1/(s1-s2)*Math.exp(s2*t);
    }
  }

  // Block diagram layout
  const bdY=14, bdH=120;
  // boxes
  const sumX=80, ctrlX=190, plantX=370, outX=570;
  const fbX=370, fbY=bdY+bdH*0.82;
  const sensorX=230;

  function box(x,y,w,h,label,sublabel,color,bg){
    return <g>
      <rect x={x} y={y} width={w} height={h} rx={4} fill={bg} stroke={color} strokeWidth="1.8"/>
      <text x={x+w/2} y={y+h/2-4} textAnchor="middle" fontSize="12" fill={color} fontWeight="700">{label}</text>
      <text x={x+w/2} y={y+h/2+12} textAnchor="middle" fontSize="10.5" fill="#555" fontFamily="'Courier New',monospace">{sublabel}</text>
    </g>;
  }

  function arrowLine(x1,y1,x2,y2,color='#1F3864'){
    return <line x1={x1} y1={y1} x2={x2} y2={y2} stroke={color} strokeWidth="1.8" markerEnd="url(#arrowB)"/>;
  }

  // Step response plot
  const gX=14, gY=154, gW=870, gH=170;
  const ox=gX+55, oy=gY+gH-18, scx=(gW-70)/7, scy=(gH-28);
  const tx=t=>ox+t*scx, ty=y=>oy-y*scy;

  function curvePath(zeta,col){
    let d=''; let pen=false;
    for(let t=0;t<=7;t+=0.04){
      const y=stepResp(zeta,t);
      if(y<-0.2||y>2){pen=false;continue;}
      const px=tx(t), py=ty(y);
      if(py<gY||py>gY+gH){pen=false;continue;}
      d+=(pen?'L':'M')+px.toFixed(1)+' '+py.toFixed(1)+' '; pen=true;
    }
    return <path d={d} fill="none" stroke={col} strokeWidth="2.2"/>;
  }

  const midBlockY = bdY + bdH*0.28;

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Transfer Functions and Closed-Loop Step Response — H(s) = ωₙ²/(s² + 2ζωₙs + ωₙ²)</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{ width:'100%', display:'block' }}>
        <Defs/>

        {/* ── Block diagram ── */}
        {/* R(s) input */}
        <text x={18} y={midBlockY+5} fontSize="13" fill="#1F3864" fontWeight="700">R(s)</text>
        {arrowLine(52, midBlockY, sumX-2, midBlockY)}

        {/* Summing junction circle */}
        <circle cx={sumX} cy={midBlockY} r={14} fill="#fff" stroke="#1F3864" strokeWidth="1.8"/>
        <text x={sumX} y={midBlockY+5} textAnchor="middle" fontSize="16" fill="#1F3864">Σ</text>
        <text x={sumX-10} y={midBlockY-6} fontSize="10" fill="#27ae60" fontWeight="700">+</text>
        <text x={sumX-10} y={midBlockY+16} fontSize="10" fill="#c0392b" fontWeight="700">−</text>

        {arrowLine(sumX+14, midBlockY, ctrlX, midBlockY)}
        {box(ctrlX, midBlockY-20, 120, 40, 'Controller', 'C(s)', '#27ae60', '#f0fff4')}
        {arrowLine(ctrlX+120, midBlockY, plantX, midBlockY)}
        {box(plantX, midBlockY-20, 140, 40, 'Plant / System', 'P(s)', '#2E75B6', '#EBF3FB')}
        {arrowLine(plantX+140, midBlockY, outX+60, midBlockY)}
        <text x={outX+66} y={midBlockY+5} fontSize="13" fill="#1F3864" fontWeight="700">Y(s)</text>

        {/* Feedback path */}
        <line x1={outX+50} y1={midBlockY} x2={outX+50} y2={fbY} stroke="#1F3864" strokeWidth="1.8"/>
        <line x1={outX+50} y1={fbY} x2={sensorX+110} y2={fbY} stroke="#1F3864" strokeWidth="1.8"/>
        {box(sensorX, fbY-18, 110, 36, 'Sensor', 'H(s)', '#c0392b', '#fff0f0')}
        <line x1={sensorX} y1={fbY} x2={sumX} y2={fbY} stroke="#1F3864" strokeWidth="1.8"/>
        <line x1={sumX} y1={fbY} x2={sumX} y2={midBlockY+14} stroke="#1F3864" strokeWidth="1.8" markerEnd="url(#arrowB)"/>

        {/* Transfer function labels */}
        <rect x={600} y={bdY} width={292} height={bdH+4} rx={4} fill="#EBF3FB" stroke="#2E75B6" strokeWidth="1.2"/>
        <text x={746} y={bdY+18} textAnchor="middle" fontSize="12" fill="#1F3864" fontWeight="700">Closed-Loop Transfer Function</text>
        <text x={746} y={bdY+38} textAnchor="middle" fontSize="11.5" fill="#2E75B6" fontFamily="'Courier New',monospace">T(s) = C(s)P(s) / [1 + C(s)P(s)H(s)]</text>
        <line x1={610} y1={bdY+46} x2={886} y2={bdY+46} stroke="#ccd9ea" strokeWidth="1"/>
        <text x={746} y={bdY+62} textAnchor="middle" fontSize="11" fill="#555">Open-loop gain: G(s) = C(s)P(s)H(s)</text>
        <text x={746} y={bdY+78} textAnchor="middle" fontSize="11" fill="#555">Unity feedback: T = G/(1+G)</text>
        <text x={746} y={bdY+94} textAnchor="middle" fontSize="11" fill="#c0392b" fontWeight="700">Poles of T(s) → stability of system</text>
        <text x={746} y={bdY+112} textAnchor="middle" fontSize="10.5" fill="#555">Left-half plane → stable  |  RHP → unstable</text>

        {/* ── Step response plot ── */}
        <rect x={gX} y={gY} width={gW} height={gH} rx={4} fill="#fff" stroke="#ccd9ea"/>
        <text x={gX+gW/2} y={gY-7} textAnchor="middle" fontSize="12" fill="#1F3864" fontWeight="700">
          Unit Step Response for ωₙ=2, varying damping ratio ζ
        </text>

        {/* Grid */}
        {[0,1,2,3,4,5,6,7].map(v=>(
          <g key={v}>
            <line x1={tx(v)} y1={gY} x2={tx(v)} y2={gY+gH} stroke="#f0f0f0" strokeWidth="1"/>
            <text x={tx(v)} y={oy+13} textAnchor="middle" fontSize="10" fill="#bbb">{v}</text>
          </g>
        ))}
        {[0.5,1.0,1.5].map(v=>(
          <g key={v}>
            <line x1={ox} y1={ty(v)} x2={tx(7)} y2={ty(v)} stroke="#f5f5f5" strokeWidth="1"/>
            <text x={ox-6} y={ty(v)+4} textAnchor="end" fontSize="10" fill="#bbb">{v}</text>
          </g>
        ))}
        <line x1={ox} y1={gY+4} x2={ox} y2={gY+gH} stroke="#1F3864" strokeWidth="1.3"/>
        <line x1={ox} y1={oy} x2={tx(7)} y2={oy} stroke="#1F3864" strokeWidth="1.3"/>
        <text x={tx(7)+8} y={oy+4} fontSize="12" fill="#1F3864" fontWeight="700">t</text>
        <text x={ox+4} y={gY+14} fontSize="11" fill="#1F3864" fontWeight="700">y(t)</text>

        {/* Steady-state line */}
        <line x1={ox} y1={ty(1)} x2={tx(7)} y2={ty(1)} stroke="#888" strokeWidth="1.2" strokeDasharray="6,4"/>
        <text x={tx(6)} y={ty(1)-6} fontSize="10" fill="#888">y=1 (step)</text>

        {/* Response curves */}
        {zetas.map((z,i)=>curvePath(z,colors[i]))}

        {/* Legend */}
        {zetas.map((z,i)=>{
          const lx=ox+12+i*155, ly=gY+14;
          return <g key={z}>
            <line x1={lx} y1={ly} x2={lx+22} y2={ly} stroke={colors[i]} strokeWidth="2.2"/>
            <text x={lx+26} y={ly+4} fontSize="11" fill={colors[i]} fontWeight="700">ζ={z}</text>
          </g>;
        })}
      </svg>
      <div style={S.dCaption}>The standard second-order system H(s)=ωₙ²/(s²+2ζωₙs+ωₙ²) illustrates how the pole locations govern step response behaviour. Underdamped systems (ζ&lt;1, red/orange) exhibit overshoot and oscillation; critically damped (ζ=1) is the fastest non-oscillatory response; overdamped (ζ&gt;1, blue) is sluggish but stable. The closed-loop transfer function T(s) describes how input R(s) maps to output Y(s) through the feedback loop — stability is determined entirely by the poles of T(s).</div>
    </div>
  );
}

// ── Main ─────────────────────────────────────────────────────────
export default function LaplaceTransforms() {
  return (
    <div style={S.wrapper}>
      <h1 style={S.h1}>The Laplace Transform</h1>
      <p style={S.p}>The Laplace Transform converts a function of time f(t) into a function F(s) of the complex variable s = σ + jω. While the Fourier Transform reveals which frequencies are present in a signal, the Laplace Transform goes further: it handles initial conditions naturally and accommodates growing or decaying signals that the Fourier Transform cannot. This makes it the preferred tool for solving linear ODEs, analysing electrical circuits, and designing feedback control systems. Setting s = jω recovers the Fourier Transform — the Laplace Transform is a strict generalisation.</p>

      <InfoBox title="Core Idea: Convert differential equations into algebraic equations in s" items={[
        "Forward: F(s) = L{f(t)} = ∫₀^∞ f(t)·e^(−st) dt  — the multiplying e^(−st) ensures convergence for growing signals",
        "Inverse: f(t) = L⁻¹{F(s)} — usually done via partial fractions + table lookup, not contour integration",
        "s = σ + jω is complex; the real part σ controls convergence, the imaginary part ω is angular frequency",
        "Region of Convergence (ROC): the set of s values for which the integral converges",
        "Poles of F(s): values of s where F(s)→∞; they encode the natural frequencies of the system",
        "Key advantage over Fourier: initial conditions are absorbed automatically by the differentiation rule",
      ]}/>

      <h2 style={S.h2}>The Transform and the s-Plane</h2>
      <DiagramBigPicture/>
      <Table2 rows={[
        ["Definition","F(s) = ∫₀^∞ f(t)·e^(−st) dt,   s = σ+jω ∈ ℂ\nOne-sided (unilateral): integrates from 0, handles causal systems with ICs"],
        ["Inverse transform","f(t) = (1/2πj)∫_{c−j∞}^{c+j∞} F(s)e^(st) ds  (Bromwich integral)\nIn practice: partial fractions → table lookup"],
        ["Region of Convergence","Set of s for which the integral converges\nFor right-sided signals: Re(s) > σ_max (rightmost pole real part)"],
        ["Relationship to Fourier","Set s=jω: F(jω) = Fourier Transform (if ROC includes imaginary axis)\nLaplace is more general — handles exponentially growing signals"],
        ["Poles","Roots of the denominator of F(s)\nLeft-half plane poles → decaying modes (stable)"],
        ["Zeros","Roots of the numerator of F(s)\nAffect amplitude/phase but not stability"],
        ["s-plane intuition","Re(s) axis: growth/decay rate; Im(s) axis: oscillation frequency\nPole at s=−a+jb → e^(−at)cos(bt) in time domain"],
      ]}/>

      <h2 style={S.h2}>Transform Pairs</h2>
      <DiagramPairs/>
      <Table2 rows={[
        ["Unit step u(t)","L{u(t)} = 1/s\nPole at s=0 (origin); constant level in time → marginally stable"],
        ["Dirac delta δ(t)","L{δ(t)} = 1  (all s)\nNo poles; flat spectrum — instantaneous impulse"],
        ["Exponential e^(−at)u(t)","L{e^(−at)u(t)} = 1/(s+a),  Re(s)>−a\nPole at s=−a; decays for a>0, grows for a<0"],
        ["Ramp t·u(t)","L{t·u(t)} = 1/s²\nDouble pole at origin; linearly growing output"],
        ["tⁿu(t)","L{tⁿu(t)} = n!/s^(n+1)\nHigher powers → higher-order pole at origin"],
        ["Sine sin(ωt)u(t)","L{sin(ωt)u(t)} = ω/(s²+ω²)\nConjugate poles at ±jω (imaginary axis)"],
        ["Cosine cos(ωt)u(t)","L{cos(ωt)u(t)} = s/(s²+ω²)\nSame poles as sine; different numerator (s vs ω)"],
        ["Damped sine e^(−at)sin(ωt)u(t)","L{·} = ω/[(s+a)²+ω²]\nPoles at −a±jω; decaying oscillation (left-half plane)"],
        ["Damped cosine e^(−at)cos(ωt)u(t)","L{·} = (s+a)/[(s+a)²+ω²]"],
      ]}/>

      <h2 style={S.h2}>Solving ODEs with Laplace</h2>
      <DiagramODESolve/>
      <Table2 rows={[
        ["Differentiation rule","L{f′(t)} = sF(s) − f(0⁻)\nL{f″(t)} = s²F(s) − sf(0⁻) − f′(0⁻)\nInitial conditions enter automatically — no undetermined coefficients needed"],
        ["Integration rule","L{∫₀ᵗf(τ)dτ} = F(s)/s\nIntegration → divide by s (adds pole at origin)"],
        ["Solve procedure","(1) Take L of both sides; (2) collect Y(s) terms; (3) partial fractions; (4) invert each term"],
        ["Cover-up rule","For simple pole at s=−a:  A = (s+a)·F(s)|_{s=−a}\nMultiply, then substitute — fastest method for distinct poles"],
        ["Repeated poles","(s+a)²: gives A/(s+a)+B/(s+a)²; use derivative to find A\nB = (s+a)²F(s)|_{s=−a}  then A = d/ds[(s+a)²F(s)]|_{s=−a}"],
        ["Heaviside step inputs","u(t−a): use time-shift property → e^(−as)/s in s-domain\nPiecewise inputs handled cleanly"],
        ["Steady-state (Final Value)","lim_{t→∞} f(t) = lim_{s→0} sF(s)  (if poles in LHP or origin only)\nRead DC gain without inverting"],
        ["Initial value","lim_{t→0⁺} f(t) = lim_{s→∞} sF(s)\nUseful sanity check on computed F(s)"],
      ]}/>

      <h2 style={S.h2}>Partial Fractions — Inverting F(s)</h2>
      <DiagramPartialFractions/>
      <Table2 rows={[
        ["When to use","F(s) is rational (ratio of polynomials) with deg(numerator) < deg(denominator)\nIf not, do polynomial long division first"],
        ["Distinct real poles","F = A/(s+a) + B/(s+b) + …\nA = (s+a)F(s)|_{s=−a}  (cover-up rule)"],
        ["Repeated pole (s+a)²","F = A/(s+a) + B/(s+a)²\nB by cover-up; A = d/ds[(s+a)²F]|_{s=−a}"],
        ["Complex conjugate pair","(s+a)²+b²: keep as quadratic, write (Cs+D)/[(s+a)²+b²]\nComplete the square to identify damped sin/cos form"],
        ["Heaviside cover-up","Fastest for distinct poles: multiply both sides by (s−pᵢ), evaluate at s=pᵢ\nNumerical: substitute actual pole value"],
        ["Verification","Multiply back out and check numerator matches\nOr check partial sums at a test value of s"],
      ]}/>

      <h2 style={S.h2}>Properties</h2>
      <DiagramProperties/>
      <Table2 rows={[
        ["Linearity","L{af(t)+bg(t)} = aF(s)+bG(s)\nTransform a sum by summing transforms"],
        ["Time shift (delay)","L{f(t−a)u(t−a)} = e^(−as)F(s),  a≥0\nDelay → multiply by e^(−as); used for switched/piecewise inputs"],
        ["s-domain shift","L{e^(at)f(t)} = F(s−a)\nMultiply by exponential in time → shift all poles by +a in s-plane"],
        ["Time scaling","L{f(at)} = (1/a)F(s/a)\nCompressing time → expanding the s-domain"],
        ["Convolution","L{(f*g)(t)} = F(s)·G(s)\nConvolution in time = multiplication in s — same as Fourier convolution theorem"],
        ["Multiplication by t","L{t·f(t)} = −dF/ds\nMultiply by t → differentiate F(s); generalises to tⁿ → (−1)ⁿ dⁿF/dsⁿ"],
        ["Initial value theorem","f(0⁺) = lim_{s→∞} sF(s)  (if limit exists)\nInstant check without full inversion"],
        ["Final value theorem","f(∞) = lim_{s→0} sF(s)  (if all poles of sF(s) in LHP)\nDC gain; fails if poles on/in RHP"],
        ["Periodic function","L{f(t)} = F₁(s)/(1−e^(−Ts)),  T=period\nF₁ is the transform of one period"],
      ]}/>

      <h2 style={S.h2}>Transfer Functions and Control Systems</h2>
      <DiagramTransferFunctions/>
      <Table2 rows={[
        ["Transfer function","H(s) = Y(s)/X(s)  (with zero initial conditions)\nRatio of output to input in s-domain; characterises the system completely"],
        ["Impulse response","h(t) = L⁻¹{H(s)}\nOutput when input = δ(t); H(s) is its Laplace transform"],
        ["Step response","y(t) = L⁻¹{H(s)/s}\nSystem output for unit step input; reveals settling time, overshoot"],
        ["Poles and stability","All poles in left-half plane (Re(s)<0) → BIBO stable\nAny pole in RHP → unstable; poles on imaginary axis → marginally stable"],
        ["2nd order standard form","H(s) = ωₙ²/(s²+2ζωₙs+ωₙ²)\nωₙ = natural frequency, ζ = damping ratio"],
        ["Damping cases","ζ<1: underdamped (oscillatory); ζ=1: critically damped (fastest stable)\nζ>1: overdamped (sluggish, no overshoot)"],
        ["Closed-loop T(s)","T(s) = G(s)/(1+G(s))  for unity feedback, G = open-loop gain\nPoles of T determine stability — place them with controller design"],
        ["Frequency response","H(jω) = H(s)|_{s=jω} — magnitude and phase vs frequency\nBode plot: |H(jω)| in dB and ∠H(jω) in degrees vs log(ω)"],
      ]}/>

      <InfoBox title="Key Takeaway — Laplace Problem-Solving Checklist" items={[
        "Need to solve an ODE with initial conditions? → Take L of both sides; ICs appear automatically via sF(s)−f(0)",
        "Got Y(s) — now what? → Factor denominator, identify pole types, decompose by partial fractions, invert each term",
        "Distinct real pole at s=−a → A·e^(−at)u(t);  find A by cover-up: A=(s+a)F(s)|_{s=−a}",
        "Complex poles (s+a)²+b² → e^(−at)[C₁cos(bt)+C₂sin(bt)]; complete the square to identify C₁,C₂",
        "Repeated pole at s=−a → (At+B)e^(−at); extra term per repetition",
        "Check your answer: initial value theorem (s→∞) and final value theorem (s→0) before full inversion",
        "Transfer function poles in left-half s-plane → stable system; any RHP pole → unstable",
        "Laplace vs Fourier: use Laplace when initial conditions matter or for control design; Fourier for steady-state frequency analysis",
      ]}/>
       <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                                    <img src={ODEImg5} alt="laplace table" width="65%"/>
                                </div>
                                <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                                    <img src={ODEImg6} alt="laplace table" width="65%"/>
                                </div>
                                <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                                    <img src={ODEImg7} alt="laplace table" width="65%"/>
                                </div>
                                <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                                    <img src={ODEImg8} alt="laplace table" width="65%"/>
                                </div>
    </div>
    
  );
}